import React, { Component } from 'react'
import MountContext from './MountContext'
class MountProvider extends Component {
  render () {
    const { mount, mountKey, allMounts } = this.props
    mount.mountKey = mountKey
    mount.allMounts = allMounts
    return (
      <MountContext.Provider value={mount}>
        {this.props.children}
      </MountContext.Provider>
    )
  }
}
export default MountProvider
